import React, { useEffect, useState } from 'react'
import { Link, useLoaderData, useNavigate } from 'react-router-dom'
import { acceptCaseInvite } from '../../adapters/caseResolution';
import SuccessStatus, { ErrorStatus } from '../../components/FormStatus';
import SelectInputField, { FileInput, InputField, TextAreaInput } from '../../components/Input';
import { ClaimantModal } from '../../components/user/ClaimantModel';
import { acceptCaseInviteRequest } from '../../requests/acceptCaseInvite';
import { truncateString } from '../../utils/methods';

export default function AcceptInvite() {

  const caseData = useLoaderData();

  const [defendants, setDefendants ] = useState([]);
  const [addedDefendants, setAddedDefendants ] = useState([]);
  const [ selectedDefendant, setSelectedDefendant ] = useState([]);
  const [ addDefendant, setAddDefendant ] = useState(false)
  const [errors, setErrors ] = useState([]);
  const [monetaryClaim, setMonetaryClaim ] = useState('');
  const [counterClaim, setCounterClaim] = useState('')
  const [documents, setDocumnets ] = useState([])

  const [caseFacts, setCaseFacts ] = useState({
    description: '',
    admitToClaims: '',
    sumToPay: '',
  })

  const navigate = useNavigate();
  const [submisionStatus, setSubmisionStatus] = useState(false)

  useEffect(() => {
    // setDefendants(caseData.defendants);
  }, )

  const handleAddedDocument = (value) => {
    let files = [...documents, ...value]
    setDocumnets(files);
  }

  const handleRemovedDocument = (index) => {
    const fileListArr = Array.from(documents)
    fileListArr.splice(index, 1)
    setDocumnets(fileListArr)
  }

  const handleFactInputChamge = (val, name) => {
    setErrors([]);
    caseFacts[name] = val;
    setCaseFacts(caseFacts)
  }

  const showAddDefendantModal = (e, data) => {
      e.preventDefault();
      setSelectedDefendant(data);
      setAddDefendant(true);
  }

  const hideAddDefendantModal = () => {
    setAddDefendant(false);
  }


  const submitDefendant = (data) => {
    let recordExists = Object.entries(selectedDefendant).length > 0;
    if (!recordExists) {
      addedDefendants.push(data);
      setAddedDefendants(addedDefendants)
    } else {
      const dataIndex = addedDefendants.findIndex((c) => c === selectedDefendant)
      addedDefendants[dataIndex] = data;
      setAddedDefendants(addedDefendants);
      setSelectedDefendant({});
    }
  }

  const submitForm = () => {
    if (documents.length < 0) {
      setErrors(['submit at least one documnet to back your claim'])
      return;
    }

    acceptCaseInviteRequest.validate({
      personnels: addedDefendants,
      monetaryClaim,
      counterClaim,
      admitToClaims: caseFacts.admitToClaims,
      sumToPay: caseFacts.sumToPay,
      description: caseFacts.description,
    }).then( async () => {
      try {
        const data = {
          personnels: addedDefendants,
          description: caseFacts.description,
          admitToClaims: caseFacts.admitToClaims === 'Yes',
          sumToPay: caseFacts.sumToPay,
          monetaryClaim,
          counterClaim,
          evidences: documents,
        }
        await acceptCaseInvite(data, caseData._id).then((res) => {
          if(res.status === 200){
            setSubmisionStatus(true);
            setTimeout(() => {
              setSubmisionStatus(false);
              navigate('/account/dashboard', { replace: true });
            }, 3000)
          }
        })
        
      } catch (err) {
        setErrors(['An Error occured!'])
      }
    }).catch((e) => {
      setErrors(e.errors)
    })
  }
  return (
    <div>
      <div className="wrapper-2 animate__animated animate__fadeIn">
        <div className="gradient-bg relative rounded-b-lg py-12 mb-8 px-8 flex lg:items-center lg:flex-row flex-col justify-start lg:justify-between items-start gap-4">
          <div>
            <h1 className="font-fira xl:text-2xl text-xl capitalize">Invitation To Case Resolution</h1>
          </div>
          <Link to="/account/dashboard" className=" border-2 border-blue-900 px-4 py-2 gap-1 flex items-start hover:text-blue-900 rounded-lg text-gray-800 font-semibold text-xs left-8">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z" clipRule="evenodd" />
              </svg>
            </span>
            <span>
              Cancel
            </span>
          </Link>
        </div>

        <ErrorStatus errors={errors} />
        <SuccessStatus message="Case Invite Accepted successfully!" showStatus={submisionStatus} />


        <div className="px-6 mb-8 md:px-0">
          <div className="text-sm font-semibold">
            Thank you for accepting this invitation to talk and amicably resolve your dispute with [insert claimant’s name]. Please view and accept our terms of use, privacy policy and guidelines here. To proceed with the case, kindly fill in the data fields below to the best of your ability.
          </div>

          <form onSubmit={(e) => {
            e.preventDefault();
            submitForm();
          }}>
            <div className="mt-4 bg-gray-100 py-6 px-4 lg:px-8 rounded-lg border-2 border-gray-300">
              <div className="flex py-6 border-b border-blue-800 gap-3 justify-between md:flex-row flex-col items-start">
                <div className="md:w-3/6 w-full gap-2 flex md:flex-col flex-row md:justify-start justify-between md:items-start items-center">
                  <h4 className="text-sm font-semibold">
                    Involved Parties/Personnel
                  </h4>

                  <button onClick={(e) => showAddDefendantModal(e, {})} className="bg-blue-800 flex gap-1 items-center hover:bg-blue-900 text-white py-2 px-4 rounded-lg text-xs font-semibold">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                        <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 9a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25V15a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V9z" clipRule="evenodd" />
                      </svg>
                    </span>
                    <span>
                      Add Personnel
                    </span>
                  </button>
                </div>

                <div className="md:w-3/6 w-full">
                  <ul className="rounded-lg">
                    {[...defendants.map((ad) => ({
                      name: ad.name, email: ad.email, fromServer: true
                    })), ...addedDefendants.map((add) => ({
                      name: add.name,
                      email: add.email,
                      fromServer: false
                    }))].map((cmt) => {
                      return (<li key={defendants.indexOf(cmt)} className="py-4 px-4 hover:bg-gray-200 cursor-pointer border-gray-200 border-b" onClick={(e) => {
                        if(!cmt.fromServer){
                          showAddDefendantModal(e, addedDefendants[addedDefendants.findIndex((adt) => adt.name === cmt.name)])
                        }
                      }}>
                        <div>
                          <p className="font-semibold text-xs">
                            {cmt.name}
                          </p>
                          <p className="text-xs mt-1">
                            {cmt.email}
                          </p>
                        </div>
                      </li>)
                    })}
                  </ul>
                </div>
              </div>

              <div className="flex mt-3 py-6 border-b border-blue-800 gap-3 justify-between md:flex-row flex-col items-start">
                <div className="md:w-3/6 w-full gap-2 flex md:flex-col flex-row md:justify-start justify-between md:items-start items-center">
                  <h4 className="text-sm font-semibold">
                    Fact Of Case
                  </h4>
                </div>

                <div className="md:w-3/6 w-full">
                  
                  <TextAreaInput
                    onChange={(e) => {
                      handleFactInputChamge(e.target.value, 'description')
                    }}
                    isRequired={true} placeholder="Succintly state your side of the story" name="industry" defaultValue={caseFacts.description} label="Narration" />

                  <SelectInputField isRequired={true} placeholder="Do you admit the Claimant’s claims?" onChange={(e) => {
                    setErrors([]);
                    handleFactInputChamge(e.target.value, 'admitToClaims')
                  }} name="admitToClaims" id="admitToClaims" defaultValue={caseFacts.admitToClaims} label="Do you admit the Claimant’s claims?" options={["Yes", "No"]} />

                  {caseFacts.admitToClaims === 'Yes' && <InputField
                    onChange={(e) => {
                      handleFactInputChamge(e.target.value, 'sumToPay')
                    }}
                    isRequired={true} type="text" placeholder="0.00" name="sumToPay" defaultValue={caseFacts.sumToPay} label="What sum are you willing to pay the Claimant for them to walk away" />}
                </div>
              </div>
              <div className="flex mt-3 py-6 border-b border-blue-800 gap-3 justify-between md:flex-row flex-col items-start">
                <div className="md:w-3/6 w-full gap-2 flex md:flex-col flex-row md:justify-start justify-between md:items-start items-center">
                  <h4 className="text-sm font-semibold">
                    Counter-Claim
                  </h4>
                </div>

                <div className="md:w-3/6 w-full">
                  <TextAreaInput
                    onChange={(e) => {
                      setErrors([]);
                      setCounterClaim(e.target.value)
                    }}
                    placeholder="Do you have any counter-claim? If yes, please state below" name="counterClaim" defaultValue={counterClaim} label="Do you have any counter-claim? If yes, please state below" />

                  <InputField
                    onChange={(e) => {
                      setErrors([]);
                      setMonetaryClaim(e.target.value)
                    }}
                    type="text" id="monetaryClaim" placeholder="0.00" name="monetaryClaim" defaultValue={monetaryClaim} label="If you have a monetary counter-claim, state the amount, in figures" />
                </div>
              </div>

              <div className="flex mt-3 py-6 border-b border-blue-800 gap-3 justify-between md:flex-row flex-col items-start">
                <div className="md:w-3/6 w-full gap-2 flex md:flex-col flex-row md:justify-start justify-between md:items-start items-center">
                  <h4 className="text-sm font-semibold">
                    Documnets/Evidences
                  </h4>
                </div>

                <div className="md:w-3/6 w-full">
                  <FileInput
                    id="evidence"
                    onChange={(e) => {
                      setErrors([]);
                      handleAddedDocument(e.target.files);
                    }}
                    multiple={true}
                    isRequired={true} type="text" fileType="" name="evidence" defaultValue={documents} label="Add Evidence" />


                  {Array.from(documents).map((file, index) => {
                    let fileType = file['type'].split('/')[0];
                    return (<div key={index} className="mt-4 mx-3 justify-between text-blue-800 bg-white rounded-lg py-3 px-4 flex items-center text-xs font-semibold gap-6">
                      <div className="flex gap-3 items-center">
                        <span>
                          {fileType === 'image' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                            <path fillRule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z" clipRule="evenodd" />
                          </svg>}

                          {fileType === 'video' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                            <path d="M4.5 4.5a3 3 0 00-3 3v9a3 3 0 003 3h8.25a3 3 0 003-3v-9a3 3 0 00-3-3H4.5zM19.94 18.75l-2.69-2.69V7.94l2.69-2.69c.944-.945 2.56-.276 2.56 1.06v11.38c0 1.336-1.616 2.005-2.56 1.06z" />
                          </svg>}

                          {fileType === 'application' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                            <path d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625z" />
                            <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
                          </svg>}

                          {fileType === 'text' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                            <path fillRule="evenodd" d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625zM7.5 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 017.5 15zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H8.25z" clipRule="evenodd" />
                            <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
                          </svg>}
                        </span>
                        <span title={file['name']}>
                          {truncateString(file['name'])}
                        </span>
                      </div>

                      <button onClick={(e) => {
                        e.preventDefault();
                        handleRemovedDocument(index)
                      }} className="text-red-800 hover:text-red-900">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                          <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </div>)
                  })}


                </div>
              </div>
              <div className="mt-4 py-8">
                <button type="submit" className="w-full md:w-1/3 hover:bg-blue-900 text-xs md:float-right py-3 px-6 text-center font-semibold bg-blue-800 text-white rounded-lg">Submit</button>
              </div>
            </div>
          </form>
        </div>

      </div>

      {addDefendant && <ClaimantModal initState={selectedDefendant} onClose={hideAddDefendantModal} onSubmit={submitDefendant} title="Add Personnel" />}
    </div>
  )
}
